"use client";

import { useTranslations } from "next-intl";
import { LogoHorizontal } from "@/components/svgs/LogoHorizontal";
import Link from "@/lib/locale/Link";
import { useAuthenticationStatus } from "@/lib/nhost/react";

export default function LandingNav() {
  const t = useTranslations();
  const { isAuthenticated } = useAuthenticationStatus();
  return (
    <nav className="fixed top-0 left-0 w-full h-16 backdrop-blur-md border-b">
      <div className="flex justify-between items-center h-full mx-6">
        <div className="hidden md:block">
          <Link href="/" title={t("nav.homeLabel")}>
            <LogoHorizontal className="w-24" />
          </Link>
        </div>
        <div className="space-x-4">
          {isAuthenticated ? (
            <Link href="/app/auth/signed-out">{t("nav.signOutLabel")}</Link>
          ) : (
            <>
              <Link href="/app/auth/sign-in">{t("nav.signInLabel")}</Link>
              <Link href="/app/auth/sign-up">{t("nav.signUpLabel")}</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
